




import Vue, { PropOptions } from 'vue'

export default Vue.extend({
  name: 'getWindowSize',
  mounted() {
    window.addEventListener('resize', this.getWindowSize)
    this.getWindowSize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    getWindowSize() {
      const windowSize = { width: window.innerWidth, height: window.innerHeight }
      this.$store.commit('setWindowSize', windowSize)
    },
  },
})
